import { IconsType } from 'components/Icon';
import { Pages } from 'interfaces/main';
import { IntercomPlacement } from 'config/common';
import { INTERCOM_LIVE_CHAT_LAUNCHER_ID } from 'components/IntercomChat/IntercomChat.render';
import analyticsManager from 'helpers/analyticsManager';
import { ReviewedMixpanelEvents } from 'helpers/mixpanelReviewedEvents';

type HelpCenterLink = {
    icon: IconsType;
    t_name: string;
    link: string;
    onClick?: (e?: any) => void;
    id?: string;
};

export interface HelpCenterConfig {
    intercomPlacement: string;
    intercomAppId: string;
    intercomEnabled: boolean;
}

export const getHelpCenterSubMenuLinks = (cfg: HelpCenterConfig): HelpCenterLink[] => {
    const isNavBar = cfg.intercomPlacement === IntercomPlacement.navBar;
    const intercomEnabled = !!cfg.intercomAppId && cfg.intercomEnabled;

    if (!isNavBar || !intercomEnabled) {
        return [
            {
                icon: IconsType.support_piqk,
                t_name: 'side_menu.item_names.support',
                link: `/${Pages.CLIENT_SUPPORT}`,
            },
        ];
    }

    return [
        {
            icon: IconsType.support_piqk,
            t_name: 'side_menu.item_names.submit_a_request_v2',
            link: `/${Pages.CLIENT_SUPPORT}`,
            onClick: () => {
                analyticsManager.trackEvent(ReviewedMixpanelEvents.SUBMIT_REQUEST_CLICKED, {
                    current_page_url: window.location.href,
                    intercom_placement: cfg.intercomPlacement,
                });
            },
        },
        {
            icon: IconsType.message_chat_square,
            t_name: 'side_menu.item_names.live_chat',
            link: '#',
            id: INTERCOM_LIVE_CHAT_LAUNCHER_ID,
            onClick: (e?: any) => {
                e?.preventDefault?.();
                analyticsManager.trackEvent(ReviewedMixpanelEvents.LIVE_CHAT_CLICKED, {
                    current_page_url: window.location.href,
                    intercom_placement: cfg.intercomPlacement,
                });
            },
        },
    ];
};

export const getHelpCenterMenuItem = (cfg: HelpCenterConfig) => {
    const subMenuLinks = getHelpCenterSubMenuLinks(cfg);
    return [
        {
            t_name: 'side_menu.item_names.help_center',
            icon: IconsType.help_center_piqk,
            collapsible: true,
            link: `/${Pages.CLIENT_SUPPORT}`,
            subMenuLinks,
        },
    ];
};
